// @core/api/endpoints/booking/set_resource_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookableResourceResponse,
  SetResourceStatusRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Set resource status
 * Changes operational status: ACTIVE, PAUSED (vacation, temporary closure), MAINTENANCE (vehicles, equipment), RETIRED.
 */
export async function SetResourceStatus(
  resource_id: string,
  data: SetResourceStatusRequest,
  options?: RequestOptions
): Promise<BookableResourceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/status`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.post<BookableResourceResponse>(requestPath, data, requestOptions);
}
